<script setup>
import { storeToRefs } from 'pinia';
import { useLeagueStore } from '../stores/league-store';
import LeagueNavComponent from '../components/LeagueNavComponent.vue';
import { usePermissions } from '../../../auth/composables/permissions';
import defaultLogo from '../../../app/assets/event_logo.png';

/**
 * Permissions
 */
const { isAllowed } = usePermissions();

/**
 * Leagues
 */
const { league, loading } = storeToRefs(useLeagueStore());
</script>

<template>
  <div class="container">
    <div class="row my-3 align-items-center" v-if="!loading && league">
      <div class="col-12 col-md-auto">
        <div class="league-logo d-flex justify-content-center align-items-center overflow-hidden rounded-3">
          <img :src="league.logo ?? defaultLogo" class="img-fluid w-100 h-100 object-fit-cover" alt="League Logo">
        </div>
      </div>
      <div class="col align-self-end mt-3">
        <h2 class="m-0">{{ league.name }}</h2>
      </div>
      <div class="col-12 col-md-auto align-self-end">
        <RouterLink
          :to="{
            name: 'league.manage.detail',
          }"
          class="btn btn-primary mt-3 ms-md-1 w-100"
          v-if="league && isAllowed('league.manage.detail', league.security)"
        >
          Manage League
        </RouterLink>
      </div>
    </div>

    <LeagueNavComponent />

    <RouterView />
  </div>
</template>

<style scoped>
.league-logo {
  max-width: 100px;
}
@media (min-width: 576px) {
  .league-logo {
    max-width: 100px;
  }
}
@media (min-width: 768px) {
  .league-logo {
    max-width: 150px;
  }
}
@media (min-width: 992px) {
  .league-logo {
    max-width: 200px;
    max-height: 200px;
  }
}
</style>
